<template>
  <b-row>
    <b-col class="flex f-right">
      <b-button class="mt-2 blinki-submit-btn" type="button" variant="primary" @click="$bvModal.hide(modal_name)">
        Fermer
      </b-button>
    </b-col>
  </b-row>
</template>

<script>

    export default {
        name: "close-btn-container",
        props:['modal_name']
    }
</script>

<style scoped>

</style>
